/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const DestinationHealthSummary = zod
	.object({
		avg_latency_ms: zod.number().describe('Average latency in ms'),
		max_latency_ms: zod.number().describe('Maximum latency in ms'),
		min_latency_ms: zod.number().describe('Minimum latency in ms'),
		p95_latency_ms: zod.number().describe('95th percentile latency in ms'),
		success_rate: zod.number().describe('Success rate percentage'),
		total_attempts: zod.number().describe('Total delivery attempts'),
		total_delivered: zod.number().describe('Successful deliveries'),
		total_failed: zod.number().describe('Failed deliveries')
	})
	.describe('Destination health summary');

export type DestinationHealthSummary = zod.input<typeof DestinationHealthSummary>;
export type DestinationHealthSummaryOutput = zod.output<typeof DestinationHealthSummary>;
